export const TYPES = {
  SNAP_PAYRATE_SETTINGS_REQUEST: "SNAP_PAYRATE_SETTINGS_REQUEST",
  SNAP_PAYRATE_SETTINGS_SUCCESS: "SNAP_PAYRATE_SETTINGS_SUCCESS",
  SAVE_PAYRATE_SETTING_SUCCESS: "SAVE_PAYRATE_SETTING_SUCCESS",
};
